import getLastSegmentUrl from '#client/utils/getLastSegmentUrl';

import { MAIN_ENTRY_PAGES } from '../constants/entryPages';

/**
 * Constructs a pathname for Plaid callback based on the provided parameters.
 * @param {string} pathname - The original pathname.
 * @param {string} [modalName=''] - The optional modal name to be appended.
 * @returns {object} - An object containing the constructed pathName and entry page flag.
 */
export const buildPlaidCallbackUrl = (pathname, modalName = '') => {
  const entryPage = getLastSegmentUrl(pathname);
  const isMainEntryPage = entryPage && MAIN_ENTRY_PAGES.includes(entryPage.toLowerCase());

  return {
    pathFormatted: isMainEntryPage
      ? `${pathname}?modal=${modalName}`
      : `${pathname}?plaidCallback=true`,
    isMainEntryPage
  };
};
